import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { getIcepacksStatesRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import {
	GET_ICEPACKS_STATES,
	setIcepacksStatesAction,
	setIsIcepacksStatesLoadingAction,
	setPaginationAction,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getIcepacksStatesSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsIcepacksStatesLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getIcepacksStatesRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setIcepacksStatesAction(
					data?.map(icepackState => ({
						...icepackState,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=icepack_state&id=${icepackState.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsIcepacksStatesLoadingAction(false));
	}
}

export default function* icepacksStatesContainerSaga() {
	yield takeEvery(GET_ICEPACKS_STATES, getIcepacksStatesSaga);
}
